export default {
  domainDirectory: {
    title: "Domínios oficiais", subtitle: "Confira os endereços oficiais aqui. Toque para copiar.", available: " acessíveis",
    loading: "Carregando domínios…", loadFailed: "Não foi possível carregar os domínios", retry: "Recarregar", empty: "Nenhum domínio ativo",
    tapToCopy: "Toque para copiar", checking: "Verificando", checkingShort: "Verificando", online: "Acessível", offline: "Tempo de conexão esgotado",
    waiting: "Aguardando teste", timeout: "Tempo esgotado", testAll: "Testar todos os domínios agora", updatedEveryFifteenSeconds: "A conexão é testada automaticamente a cada 15 segundos",
    saveReminder: "Faça uma captura desta página para guardar os dados dos domínios", copied: "Domínio copiado",
    names: { primary: "Domínio principal", chinaAccel: "Aceleração na China", secondary: "Domínio secundário" },
  },
  nickname: {"edit": "Editar apelido", "hint": "2–20 letras chinesas/inglesas, dígitos ou _", "saved": "Apelido salvo", "taken": "Este apelido já está em uso", "invalid": "Use 2–20 letras chinesas/inglesas, dígitos ou _. Nomes reservados não são permitidos.", "failed": "Não foi possível salvar. Tente novamente."},
  common: {
    confirm: "Confirmar",
    cancel: "Cancelar",
    search: "Pesquisar",
    language: "Idioma",
    switched: "Alterado",
    currentLanguage: "Idioma Atual",
    selectLanguage: "Selecionar Idioma",
    loading: "Carregando...",
    loadingMore: "Carregando mais...",
    noMoreData: "Não há mais dados",
    noData: "Sem dados",
    serverUnavailable: "Servidor temporariamente indisponível",
    loadFailed: "Falha ao carregar",
    requestFailed: "Falha na solicitação",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Por favor, não envie novamente",
    fee: "Taxa",
    tip: "Aviso",
    connecting: "Conectando...",
    connectWalletFirst: "Conecte sua carteira primeiro",
    connect: "Conectar",
    insufficientBalance: "Saldo insuficiente",
    developing: "Funcionalidade em desenvolvimento",
    copyFailed: "Falha ao copiar",
    sessionAuthRelogin: "Entrar novamente",
    sessionAuthStay: "Permanecer",
    pleaseRelogin: "Sessão expirada, faça login novamente",
    retry: "Tocar para tentar de novo",
    submit: "Enviar",
    pager: {
      prevPage: "Anterior",
      nextPage: "Próxima",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Ir para",
      jumpConfirm: "Ir",
    },
  },
  tabbar: {
    home: "Início",
    market: "Linha do Tempo",
    timeline: "Linha do Tempo",
    prediction: "Previsão de Contrato de Eventos AI",
    createMarket: "Criar Mercado",
    planet: "Planeta",
    trade: "Negociar",
    finance: "Finanças",
    fund: "Fundo",
    assets: "Ativos",
    planethistory: "Histórico"
  },
  tradeMenu: {
    contract: "Contrato de Evento",
    insurance: "Seguro",
    spot: "À Vista",
    flash: "Troca Rápida"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "Previsão AI · Contratos de evento · Análise inteligente",
    predictionCategories: {
      hot: "Linha do Tempo",
      sports: "Esportes",
      world: "Mundo",
      politics: "Política",
      economy: "Economia"
    },
    predictionSubCategories: {
      crypto: "Spot",
      forex: "Forex",
      commodities: "Commodities"
    },
    features: {
      recharge: "Recarregar",
      rechargeDesc: "Depósito rápido",
      contract: "Contrato de Evento",
      contractDesc: "Ferramentas financeiras inovadoras",
      predict: "Previsão de IA",
      fund: "PANTA MARKET Treasury",
      invite: "Convidar Amigos",
      global: "Nós Globais"
    },
    insurance: {
      title: "Pool de Seguro de Contrato (TAKER)",
      aiPoolTitle: "Pool de seguro AI",
      ordinaryPoolTitle: "Pool de valor do seguro comum",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (ref.)",
      more: "Saiba Mais",
      yesterday: "Adicionado Ontem",
      service: "Serviço Inteligente"
    },
    market: {
      tabs: {
        main: "Principal",
        hot: "Popular",
        rise: "Maiores Ganhos",
        price: "Preço"
      },
      headers: {
        pair: "Par",
        latest: "Último Preço",
        change: "Variação 24h"
      },
      viewMore: "Ver Mais",
      collapse: "Recolher"
    },
    announcement: {
      title: "Anúncio",
      heading: "Anúncio",
      text: "Bem-vindo ao PANTA MARKET. Aqui, irá experienciar o sistema único de IA e seguro de previsão criado pela PANTA MARKET, permitindo-lhe juntar-se facilmente ao mercado de previsão WEB3 e iniciar a sua jornada para a riqueza.",
      time: "2025/11/19 10:00",
      gotIt: "Entendi",
      viewDetail: "Ver detalhes",
      systemLabel: "Anúncio do sistema"
    },
    timePeriods: {
      "1min": "1 Minuto",
      "30min": "30 Minutos",
      "1hour": "1 Hora"
    },
    footer: {
      australia: "· Austrália",
      uae: "· Emirados Árabes Unidos",
      attention: "· ATENÇÃO:",
      attentionText: "PANTA MARKET é uma empresa de mercado de previsão WEB3 baseada em IA e de operação própria. Não autorizamos terceiros a cobrar taxas de qualquer forma ou nome. Para perguntas, contacte o serviço de apoio ao cliente oficial em: {email}"
    },
    timeframes: {
      "1s": "1 min",
      "1m": "1 min",
      "5m": "5 min",
      "15m": "15 min",
      "1h": "1 hora",
      "4h": "4 horas",
      "1d": "1 dia"
    },
    statusHotEn: "HOT",
    yes: "Sim",
    no: "Não",
    hotBannerTitle: "Contrato de evento",
    homeBanner: {
      s1t1: "Com IA",
      s1t2: "Ecossistema central AstralX",
      s1cta: "AstralX",
      s2t: "Fundo Galaxy",
      s2s1: "Saiba sobre proteção de capital",
      s2s2: "e regras de pagamento",
      s2cta: "Assinar",
      s3s: "Previsão de preço",
      s3cta: "Prever",
    },
    catCrypto: "Cripto",
    catMetal: "Metais",
    catSports: "Esportes",
    catPolitics: "Política",
    catEntertainment: "Entretenimento",
    statusHot: "Em alta",
    statusLocked: "Bloqueado",
    statusLive: "Ao vivo",
    statusLockedWait: "Bloqueado, aguardando liquidação",
    jouleUnit: "JOULE",
    nowLabel: "Agora",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "Ver mais {n} opções",
    categoryAll: "Todos",
    categoryCrypto: "Cripto",
    categoryEquity: "Ações",
    categoryCommodity: "Commodities",
    categoryForex: "Forex",
    categoryMetal: "Metais"
  },
  withdraw: {
    title: "Saque",
    headerTitle: "Saque",
    address: "Endereço de Saque",
    addressLabel: "Endereço de Saque",
    addressPlaceholder: "Digite ou cole o endereço",
    network: "Rede",
    selectNetwork: "Selecionar Rede",
    networkHint: "Certifique-se de que o endereço de saque corresponde à rede selecionada",
    withdrawAmount: "Valor de Saque",
    receiveAmount: "Valor a Receber",
    networkFee: "Taxa de Rede",
    submit: "Confirmar Saque",
    submitButton: "Sacar",
    balance: "Saldo:",
    all: "Tudo",
    amountPlaceholder: "Por favor, digite",
    minimumWithdrawal: "Valor mínimo de saque: {amount} USDT",
    fee: "Taxa",
    confirm: "Confirmar",
    confirmTitle: "Confirmar Ação",
    confirmContent: "Tem certeza de que deseja continuar?",
    toasts: {
      fetchFailed: "Falha ao buscar ativos",
      enterAddress: "Por favor, insira um endereço de saque",
      enterValidAmount: "Por favor, insira um valor de saque válido",
      insufficientBalance: "Saldo insuficiente",
      minimumAmount: "Valor mínimo de saque é {amount} USDT",
      processing: "Processando...",
      success: "Saque bem-sucedido!",
      requestSuccess: "Solicitação de saque bem-sucedida",
      requestFailed: "Falha no saque, por favor, tente novamente",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Depósito",
    connectPrompt: "Por favor, conecte sua carteira para depositar",
    loading: "Carregando...",
    depositAddress: "Endereço de Depósito",
    minimumDeposit: "*Depósito mínimo de 10.0000 USDT",
    depositAmount: "Valor do Depósito",
    balance: "Saldo",
    amaBalance: "Saldo TAKER",
    amount: "Valor",
    amountPlaceholder: "Digite o valor do depósito",
    minimumNotice: "*Mínimo {min} {token}",
    processing: "Processando...",
    confirm: "Confirmar Depósito",
    confirmTitle: "Confirmar Ação",
    confirmContent: "Tem certeza de que deseja continuar?",
    helpText: "O depósito chamará o método recharge do contrato inteligente, é necessário aprovar o token TAKER",
    toasts: {
      copySuccess: "Copiado com sucesso",
      dataLoadFailed: "Falha ao carregar dados",
      enterValidAmount: "Por favor, insira um valor de depósito válido",
      invalidAmount: "O valor do depósito não pode ser menor que {min} TAKER",
      invalidAddress: "Endereço de depósito inválido",
      checkingAllowance: "Verificando limite...",
      approving: "Aprovando...",
      approveSuccess: "Aprovação bem-sucedida",
      depositing: "Depositando...",
      depositSuccess: "Depósito bem-sucedido",
      depositFailed: "Falha no depósito",
      balanceLoadFailed: "Não foi possível ler o saldo de USDT de teste. Atualize e tente novamente",
      contractError: "Falha na chamada do contrato, verifique o saldo",
      userCancelled: "Você cancelou a operação",
      insufficientFunds: "Saldo insuficiente",
      wrongNetwork: "Por favor, mude para a rede correta",
      requestingAuth: "Solicitando autorização da carteira...",
      waitingConfirmation: "Aguardando confirmação da transação...",
      transactionFailed: "Falha ao iniciar a transação",
      transactionCancelled: "Você cancelou a transação",
      genericError: "Falha na transação",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "Minha Equipe",
    contractEarnings: "Meus Ganhos de Contrato",
    btcFund: "Rendimento financeiro",
    stats: {
      teamSubscribed: "Stake da equipe",
      personalSubscribed: "Stake pessoal",
      totalTeam: "Volume da equipe",
      periodTeam: "Ganhos da equipe",
      periodPersonal: "Volume pessoal",
      personalEarnings: "Ganhos acumulados pessoais",
      teamEarnings: "Ganhos da equipe",
      personalVolume: "Volume pessoal",
      teamVolume: "Volume da equipe",
      personalPower: "Poder Pessoal",
      teamTotalPower: "Poder Total da Equipe"
    },
    links: {
      invite: "Convidar Amigos",
      details: "Detalhes da Equipe"
    },
    inviteBannerTitle: "Convide amigos e desbloqueie comissões",
    inviteBannerSubtitle: "Desbloqueie as comissões da equipe",
    inviteBannerCta: "Participar agora",
    unclassifiedHint: "Origem histórica de pagamento a revisar: {amount} {asset}"
  },
  my: {
    headerTitle: "Minha Conta",
    login: "Toque para Entrar",
    inviteCode: "Código de Convite:",
    groups: {
      common: "Funções Comuns",
      trading: "Negociação",
      finance: "Finanças",
      help: "Ajuda"
    },
    features: {
      invite: "Convidar Amigos",
      team: "Minha Equipe",
      insurance: "Seguro de Contrato de Evento",
      contract: "Contrato de Evento",
      exchange: "Troca",
      fund: "Fundo do Tesouro de IA",
      communitySquare: "Praça da comunidade",
      createEvent: "Criar evento",
      community: "Comunidade Oficial",
      terms: "Termos de Serviço",
      announcement: "Anúncios",
      privacy: "Política de Privacidade",
      aboutUs: "Sobre nós"
    }
  },
  finance: {
    title: "A página de finanças está em desenvolvimento..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "Falha na troca: requisitos não atendidos",
    internalPrice: "Preço interno",
    marketPrice: "Preço de mercado",
    coinBasis: "Base em moeda",
    legacyBasis: "Base em moeda",
    contractBasis: "Base de liquidação",
    unitPrice: "Preço unitário de compra",
    quotaUsed: "Compras internas acumuladas",
    quotaRemaining: "Cota interna restante",
    quotaHint: "Limite vitalício de {limit} PANTA em todos os planos. Desativação, vencimento ou mudança de VIP não zeram o acumulado.",
    principal: "Principal",
    principalReturn: "Principal devolvido no vencimento",
    dailyYield: "Rendimento bruto diário",
    coinYieldHint: "Rendimento bruto diário = principal PANTA × taxa anual ÷ 360, arredondado para baixo em unidades atômicas. O preço não altera as moedas do contrato. Distribuição conforme as regras aplicáveis.",
    legacyHint: "Contrato baseado em moeda. A devolução do principal em PANTA usa o preço de vencimento previsto no contrato.",
    quotaError: "Cota interna excedida. Reduza a quantidade; não há divisão nem mudança automática para preço de mercado.",
    permissionChanged: "Plano indisponível para seu VIP atual. Lista atualizada.",
    quoteChanged: "Preço ou elegibilidade alterados. Confira a nova cotação e confirme novamente.",
    quoteExpired: "Cotação expirada. Atualize e confira antes de confirmar.",
    retryQuote: "Atualizar cotação",
    stakeGateTitle: "Staking necessário para vender PANTA",
    stakeGateBody: "VIP{vip}: staking ativo {staked} PANTA; necessário {required} PANTA; faltam {shortfall} PANTA. Apenas a venda é restrita; compras não são afetadas.",
    goStake: "Ir para staking",
    refreshEligibility: "Atualizar elegibilidade",
  },
  fundPage: {
    heroTitle: "Rendimentos PANTA distribuídos diariamente",
    heroDesc: "Assine o fundo Galaxy e receba dividendos anualizados",
    learnMore: "Saiba mais",
    allProducts: "Todos os produtos",
    subscribe: "Assinar",
    stake: "Stake",
    stakePreview: "Prévia do stake",
    searchCoin: "Buscar moeda",
    allPeriods: "Todos os períodos",
    colCoin: "Nome do fundo",
    colApy: "APY em token",
    colTerm: "Prazo",
    fixedTerm: "Prazo fixo",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Prazo",
    apyLabel: "APY",
    stakeCap: "Posição individual",
    stakeAmount: "Valor do stake",
    estEarnings: "Rendimento estimado",
    stakeDisclaimer: "O rendimento é ilustrativo e não garantido. Cerca de 70% vai ao saldo disponível e 30% a fundos de teste; os fundos de teste são liberados após ~3x de volume.",
    stakeSuccess: "Stake concluído",
    annualized: "APY de referência",
    perShareYield: "Rendimento / 10 mil (WBS)",
    dayUnit: "d",
    empty: "Ainda não há produtos de fundo",
    loadFailed: "Falha ao carregar",
    rulesTitle: "Informações do fundo",
    gotIt: "Entendi",
    pantaAvailable: "PANTA disponível",
    activeFaceValue: "Cotas ativas",
    totalReward: "Rendimento acumulado do fundo (PANTA)",
    fundYieldUnavailable: "--/Atualize o serviço",
    effectiveVip: "Nível efetivo",
    myHoldings: "Histórico de compra do fundo",
    faceValue: "Valor",
    maturity: "Vencimento",
    stakeStart: "Horário do stake",
    pantaPrice: "Preço PANTA",
    noMoreHoldings: "Não há mais posições",
    subscriptionStatus: {
      ACTIVE: "Ativo",
      SETTLED: "Liquidado",
      CANCELLED: "Cancelado",
      MANUAL_REVIEW: "Revisão manual",
    },
    minPanta: "Mín. PANTA",
    pantaAmount: "Quantidade da assinatura (PANTA)",
    stepHint: "Múltiplo de {step}, mín. {min}",
    getQuote: "Obter cotação",
    confirmStake: "Confirmar stake",
    jouleDebit: "Débito de JOULE",
    expectedPanta: "PANTA em stake",
    quoteExpires: "Cotação válida até",
    unavailable: "Indisponível",
    invalidAmount: "Insira uma quantidade PANTA válida no passo",
    quoteFailed: "Falha na cotação",
    rewards: "Recompensas do fundo",
    unlock: "Lotes de congelamento PANTA",
    unlockProgress: "Volume de negociação usado",
    pantaLedger: "Razão PANTA"
  },
  finanfund: {
    title: "Fundo de Tesouraria TAKER",
    subtitle: "Simples, Eficiente, Ganhos Fáceis",
    productName: "Fundo de Tesouraria TAKER",
    minAmount: "Valor Mínimo",
    incomeRatio: "Taxa de Retorno",
    lockPeriod: "Período de Bloqueio",
    dailyReturn: "Retorno Diário",
    earning: "Ganho",
    redemptionRules: "Regras de Resgate",
    rules: {
      rule1: "O Fundo de Tesouraria TAKER não pode ser resgatado após custódia",
      rule2: "Os ganhos diários são creditados automaticamente",
      rule3: "O valor bloqueado será devolvido após o término do período de bloqueio"
    },
    subscription: "Subscrição",
    amountPlaceholder: "Digite o valor",
    balance: "Saldo",
    availableFunds: "Fundos Disponíveis",
    all: "Tudo",
    subscribeButton: "Subscrever",
    toasts: {
      productIdNotExist: "ID do produto não existe",
      enterValidAmount: "Por favor, digite um valor de subscrição válido",
      minAmountRequired: "O valor da subscrição não pode ser inferior a {amount} USDT",
      subscribeSuccess: "Subscrição bem-sucedida",
      subscribeFailed: "Falha na subscrição"
    }
  },
  community: {
    title: "Comunidade Oficial",
    bannerTitle1: "Junte-se à Nossa Comunidade",
    bannerTitle2: "Conecte-se com Usuários Globais",
    linkCopied: "Link Copiado"
  },
  invite: {
    headerTitle: "Convidar Amigos",
    rulesEntry: "Regras de Convite",
    subtitle: "Ganhe em cada trade da equipe",
    mainTitle: "Convide e Ganhe",
    description: "Compartilhe o link — amigos negociam, você ganha",
    yourCode: "Seu Código",
    shareLink: "Link de Compartilhamento",
    inviteButton: "Convidar Amigos",
    subTitle: "Receba Altas Comissões",
    viewRules: "Ver Regras",
    rulesLink: "Ver Regras de Indicação >",
    rulesTitle: "Regras de Indicação",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Convidar Amigos",
    referralCode: "Código de Indicação",
    inviteLink: "Link de Convite",
    loading: "Carregando...",
    copyButton: "Copiar Link de Convite",
    toasts: {
      emptyContent: "Conteúdo vazio",
      copySuccess: "Copiado com sucesso",
      bindSuccess: "Vinculação bem-sucedida",
      bindFailed: "Vinculação falhou",
      alreadyBound: "Superior já vinculado; não é possível alterar",
      loginFirst: "Conecte a carteira primeiro",
      invalidCode: "Digite um código de convite ou endereço válido",
      cannotBindSelf: "Não é possível vincular a si mesmo",
    },
    boundLabel: "Superior vinculado",
    modalDesc: "Ainda não vinculou um superior. Digite o código ou endereço da carteira para participar das recompensas da equipe. O link preenche automaticamente; sem convite, o superior padrão é pré-preenchido.",
    bindPlaceholder: "Digite o código ou endereço da carteira",
    bindButton: "Vincular",
    binding: "Vinculando…",
    bindSuperior: "Vincular superior",
  },
  wallet: {
    title: "Minha Carteira",
    address: "Endereço da Carteira",
    addressCopied: "Endereço copiado",
    inviteCode: "Código de Convite",
    logout: "Sair",
    login: "Entrar",
    toasts: {
      networkSwitchCancelled: "Troca de rede cancelada pelo usuário",
      networkConfigNotFound: "Configuração de rede não encontrada para {chainId}",
      signatureCancelled: "Assinatura cancelada pelo usuário",
      connectionFailed: "Falha ao conectar carteira",
      accountSwitched: "Conta da carteira alterada, por favor reconecte",
      connectionTimedOut: "Conexão expirou, tente novamente",
      loginSuccess: "Login bem-sucedido",
      logoutSuccess: "Logout bem-sucedido",
      switchNetwork: "Por favor, mude para {chainName} em sua carteira antes de tentar depositar",
      wrongChain: "Rede não suportada, por favor mude para {chainName}",
      switchingNetwork: "Mudando de rede...",
      switchNetworkFailed: "Falha ao mudar de rede, por favor mude manualmente para {chainName} em sua carteira"
    }
  },
  market: {
    title: "Mercado",
    banner: {
      title: "Contrato de Evento",
      desc: "Liberte o potencial de ganhos on-chain"
    },
    tabs: {
      main: "Moedas principais",
      rise: "Maiores altas"
    },
    types: {
      crypto: "Criptomoeda",
      stocks: "Ações EUA",
      forex: "Forex",
      commodities: "Commod.",
      favorites: "Favoritos"
    },
    headers: {
      pair: "Par de negociação",
      price: "Último preço",
      change: "Variação diária"
    },
    loading: "Carregando...",
    loadingMore: "Carregando mais...",
    noMoreData: "Não há mais dados"
  },
  notice: {
    loginRequired: "Faça login para ver os anúncios",
    empty: "Nenhum anúncio ainda",
    unpublished: "Despublicado",
    title: "Anúncios",
    helpCenter: "Central de Ajuda",
    noticeDetail: "Detalhes do Anúncio",
    viewDetail: "Ver detalhes",
    pdfViewer: "Visualizador de PDF",
    videoPlayer: "Reprodutor de Vídeo",
    imageViewer: "Visualizador de Imagem",
    documentViewer: "Visualizador de Documento",
    clickToViewPdf: "Clique para ver o PDF",
    clickToViewDocument: "Clique para ver o documento",
    openInBrowser: "Abrir no Navegador",
    tryingViewer: "Tentando método {current}/{total}",
    pdfLoadFailed: "Falha ao carregar pré-visualização do PDF, por favor baixe para visualizar",
    downloadPdf: "Baixar PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Contrato de Eventos",
    nextRound: "Próxima Rodada",
    posCurrent: "Atual",
    aiThenPrefix: 'IA na ocasião: ',
    aiUnlinked: 'Sem IA vinculada',
    aiNotRecorded: 'Não registrado',
    insuranceLabel: "Seguro",
    insuranceNotSelected: 'Não selecionado',
    insuranceInactive: "Sem efeito",
    insuranceTypeNone: "Sem efeito",
    insuranceTypeEvent: "Seguro comum ativo",
    insuranceTypeEventShort: "Seguro comum",
    insuranceTypeAi: "Seguro de IA ativo",
    insuranceTypeAiShort: "Seguro de IA",
    insuranceTypeConverted: "Este pedido foi convertido para seguro comum",
    insuranceTypeUnknown: "Status do seguro pendente",
    inProgress: "Em andamento",
    estimatedPnl: "P&L estimado",
    settlementConfirming: "A confirmar o resultado",
    balanceSyncing: "A sincronizar o saldo",
    pendingReview: "Em revisão",
    connecting: "Conectando...",
    connectWallet: "Conectar",
    orderDetail: {
      title: "Detalhes da ordem",
      orderId: "ID da ordem",
      symbol: "Par",
      interval: "Intervalo",
      direction: "Direção",
      aiDirection: "IA na altura",
      openTime: "Abertura",
      settleTime: "Expira",
      settledAt: "Liquidação",
      openPrice: "Preço de abertura",
      closePrice: "Preço de fecho",
      stake: "Capital",
      premium: "Prémio",
      netProfit: "P&L líquido",
      status: "Estado",
      orderSource: "Origem da ordem",
      converted: "Conversão de seguro",
      notRecorded: "Não registado",
      copied: "ID da ordem copiado",
    },
    orderStatus: {
      CREATED: "Criada",
      ACCEPTED: "Aceite",
      CLOSED: "Fechada",
      FUNDS_LOCKED: "Fundos bloqueados",
      AWAITING_SETTLEMENT: "A aguardar liquidação",
      PROCESSING: "A processar",
    },
    insuranceBalanceInsufficient: "Saldo da conta de seguro insuficiente",
    mainBalanceInsufficient: "Saldo da conta principal insuficiente",
    insuranceBalanceRequired: "O saldo de seguro é insuficiente; não é possível ativar o seguro",
    insuranceRulesUnavailable: "As regras de prémio não estão prontas; não é possível ativar o seguro",
    insuranceMainRequired: "O saldo principal é insuficiente; não é possível ativar o seguro",
    preferenceLoading: "A carregar definições de seguro",
    preferenceLoadFailed: "Falha ao carregar as definições de seguro; toque para tentar novamente",
    preferenceSaveFailed: "Falha ao guardar as definições de seguro; tente novamente",
    preferenceSessionEndedSaveFailed: "A ronda terminou, mas a definição de desligar não foi guardada",
    premiumEstimate: "Prémio estimado {premium} JOULE ({rate}%)",
    premiumShortfallHint: "A conta de seguro está em falta de {amount} JOULE",
    premiumEstimateUnavailable: "Ainda não é possível estimar o prémio",
    premiumBoundEstimate: "Prémio estimado da estratégia vinculada {premium} JOULE",
    insuranceConfirmTitle: "Confirmar prémio",
    insuranceConfirmBody: "Pré-visualização do prémio {premium} JOULE. A pré-visualização é final. Confirme para submeter.",
    platformLadder: {
      title: "Cotações de referência da plataforma",
      current: "Preço",
      ask: "Venda{n}",
      bid: "Compra{n}",
      disclaimer: "Preços processados pela plataforma; quantidades de referência da exchange. Não são ordens executáveis.",
      unavailable: "Cotações de referência indisponíveis",
    },
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "Comprar",
      sell: "Vender"
    },
    holdings: {
      current: "Posições",
      history: "Histórico",
      currentCount: "Posições abertas {n}",
      empty: "Sem posições",
      historyEmpty: "Sem histórico"
    },
    position: {
      openPrice: "Preço de Entrada",
      closePrice: "Preço de Saída",
      profitLoss: "L/P",
      countdown: "Liquidação em",
      calculating: "Calculando...",
      settled: "Liquidado",
      settling: "Liquidando",
      active: "Ativo",
      settledAt: "Liquidado em"
    },
    modal: {
      amountPlaceholder: "Digite o valor"
    },
    pairSelector: {
      title: "Selecionar Par",
      searchPlaceholder: "Pesquisar moedas"
    },
    errors: {
      dataNotReady: "Carregando dados, por favor aguarde"
    },
    marketPause: {
      default: "Mercado temporariamente indisponível. Tente novamente mais tarde.",
      lastPriceStreamWarming: "Feed de preço em preparação. Tente novamente em breve.",
      marketWarming: "Mercado em preparação. Tente novamente em breve.",
      recovering: "Mercado em recuperação. Tente novamente em breve.",
      clockNotSynced: "Relógio do servidor não sincronizado. Tente novamente em breve.",
      symbolUnavailable: "Este par de negociação não está disponível"
    },
    toasts: {
      connectSuccess: "Conectado com sucesso",
      connectCancelled: "Você cancelou a conexão",
      connectFailed: "Falha na conexão"
    },
    openPriceLabel: "Abertura",
    secondsUnit: "s",
    amountLabel: "Valor",
  },
  exchange: {
    title: "Troca Rápida",
    from: "De",
    to: "Para",
    balance: "Saldo",
    all: "Tudo",
    placeholder: "Por favor, digite",
    fee: "Taxa",
    minAmount: "Valor mínimo de troca: {amount} {symbol}",
    button: "Trocar",
    tradeButton: "Negociar",
    paymentCurrency: "Moeda de pagamento",
    estimatedGasFee: "Taxa de gás estimada",
    gasPaymentNote: "Usará o saldo GetGas para pagar a taxa de gás",
    slippage: "Deslizamento",
    auto: "Auto",
    approximately: "Aprox",
    minReceived: "Mínimo recebido",
    exchangeRate: "Taxa de câmbio",
    finalAmount: "Valor final",
    confirm: "Confirmar",
    swapSuccess: "Troca rápida bem-sucedida!",
    swapping: "Trocando...",
    confirmTitle: "Confirmar Ação",
    confirmContent: "Tem certeza de que deseja continuar?",
    toasts: {
      fetchFailed: "Falha ao buscar ativos",
      enterValidAmount: "Por favor, insira um valor válido",
      minAmount: "O valor mínimo de troca é {amount} {symbol}",
      swapSuccess: "Troca bem-sucedida",
      requestFailed: "Falha na solicitação",
      insufficientBalance: "Saldo insuficiente, não é possível trocar",
      usdtRestricted: "USDT under review; exchange unavailable",
      quoteExpired: "Cotação expirada, confirme novamente",
      amountStepInvalid: "Valor não atende o passo exigido; ajuste e tente de novo"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    rateHintPair: "{from} {fromSymbol} = {to} {toSymbol}",
    rateHintUsdtToJoule: "Valor líquido conforme cotação",
    rateHintJouleToUsdt: "Inclui taxa; valor líquido conforme cotação",
    rateHintPantaFree: "Sem taxa por enquanto; valor líquido conforme cotação",
    feeZero: "Taxa: 0 (isenta)",
    feeLabel: "Taxa: {fee} {symbol}",
    grossLabel: "Bruto: {amount} {symbol}",
    netLabel: "Líquido: {amount} {symbol}",
    pantaEffectivePrice: "Preço efetivo PANTA: {price} U",
    pantaViaUsdtHint: "Via USDT: {price} U/PANTA · 1 U = {joulePerUsdt} JOULE",
    quoting: "Buscando cotação…",
    configFee: "Taxa Joule → USDT {fee}",
    configLimits: "Taxa {fee} · Limite de valor bruto {min}–{max} U",
    unlimited: "Ilimitado",
    quoteFailed: "Não foi possível obter cotação, tente novamente"
  },
  globalNode: {
    title: "Nó Global"
  },
  eventInsurance: {
    title: "Seguro de Contrato de Evento",
    availableBalance: "Saldo Disponível (USDT)",
    fundTransfer: "Transferência de Fundos",
    fundHistory: "Histórico de Fundos",
    type: "Tipo: ",
    all: "Todos",
    transfer: "Transferência",
    fundTransferTitle: "Transferência de Fundos",
    currency: "Moeda",
    from: "De",
    to: "Para",
    availableAccount: "Conta Disponível",
    contractInsuranceAccount: "Conta de Seguro de Contrato",
    pleaseEnter: "Por favor introduza",
    confirmTransfer: "Confirmar Transferência",
    insufficientBalance: "Saldo insuficiente",
    transferSuccess: "Transferência bem-sucedida",
    transferFailed: "Falha na transferência",
    transferring: "Transferindo...",
    noRecords: "Sem registros",
    selectAccount: "Selecionar conta",
    cannotTransferToSameAccount: "Não é possível transferir para a mesma conta",
    cannotTransferContractAccount: "Transferência de conta de contrato não suportada",
    contractAccount: "Conta de contrato (TAKER)",
    rulesTab: "Visão geral",
    agreementTab: "Acordo completo",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Regras de previsão de contrato de evento",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. Regras de previsão AI",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market Acordo de Seguro do Plano de Proteção de Negociação de Contratos de Eventos\n\n【Aviso importante】Antes de utilizar este serviço, leia atentamente e compreenda plenamente todo o conteúdo do acordo. O sistema considerará que, ao o utilizador ativar o 「Interruptor de seguro」, leu, compreendeu e aceitou plenamente o acordo e os anexos, confirma que o acordo tem força legal vinculativa e concorda em cumpri-lo rigorosamente; se não concordar e não aceitar, pare imediatamente de utilizar este plano de proteção.\n\nArtigo 1: Disposições gerais e âmbito de aplicação\n\n1.1 Este acordo descreve a forma de participação, constituição de ordens, taxas, determinação de resultados, liquidação de fundos, indemnizações condicionais e direitos de nós relacionados, bem como as funções de previsão de eventos das duas funcionalidades 「Previsão de contrato de evento」 e 「Previsão de contrato de evento AI」 dentro do PANTA Market. Cada produto aplica as suas cláusulas específicas; não se podem aplicar diretamente as taxas, condições de indemnização ou regras de nós de um produto ao outro.\n1.2 A previsão de contrato de evento é a funcionalidade em que o utilizador emite um juízo sobre um evento previamente indicado e os seus resultados opcionais, utiliza JOULE para submeter e criar uma ordem. A perda qualificada final pode, segundo regras aprovadas, gerar limite de nó pessoal ou de equipa comunitária; esse limite não constitui indemnização em dinheiro imediata. A previsão de contrato de evento AI é a funcionalidade em que o utilizador, com referência ao sinal válido de direção de previsão AI fornecido pelo sistema, confirma participação ordem a ordem segundo o montante fixo e a ordem do plano selecionado para criar ordens. Quando as 8 ordens de uma mesma sequência qualificada são totalmente liquidadas e todas resultam em perda, cumprindo simultaneamente outras condições explícitas, a indemnização em JOULE é calculada a 90% do total do capital principal qualificado. O sinal AI não garante o resultado, e a indemnização condicional não cobre todas as despesas.\n1.3 Este acordo, os parâmetros versionados do produto correspondente, as regras específicas do evento e a página de confirmação do utilizador constituem conjuntamente as regras completas. A página só pode apresentar parâmetros já aprovados e não pode substituir a ausência de condições essenciais pela expressão 「prevalece a página」. Em caso de contradição entre documentos, devem suspender-se novas operações afetadas e explicar, verificar e corrigir; não se pode escolher unilateralmente depois uma interpretação menos favorável ao utilizador para tratar ordens existentes.\n1.4 Este projeto envolve ativos reais, previsão de eventos, indemnizações condicionais e designação de seguro, recompensas de equipa, troca e pools de fundos, e não é um produto que possa omitir a revisão de risco e conformidade. A natureza jurídica, licenças, regiões de prestação, elegibilidade de utilizadores, AML, proteção do consumidor e requisitos de tratamento de dados de cada funcionalidade devem ser verificados profissionalmente conforme o âmbito real do serviço. Cláusulas de isenção de responsabilidade não substituem licenças necessárias, disposição de fundos e medidas de controlo; este rascunho não pressupõe a aplicação da lei de um país específico nem afirma que o produto já está legalmente autorizado a operar.\n\nArtigo 2: Terminologia e estado dos fundos\n\n2.1 JOULE é a unidade de medida do capital principal de previsão, prémio de seguro e indemnização AI neste produto; PANTA é a unidade de ativo utilizada na distribuição de direitos de nós e outras operações; o equivalente USDT é a base de medição para parte dos limites e cálculos de valor. Os três não podem ser misturados; a apresentação interna de valores não implica conversão imediata para moeda legal a taxa fixa, nem equivale a transferência on-chain de ativos já concluída; esta explicação não cancela direitos patrimoniais ou obrigações de pagamento já formados conforme lei e contrato.\n2.2 O capital principal da ordem é o montante em JOULE que o utilizador confirma efetivamente e que o sistema aceita nessa ordem, sem incluir o prémio. O prémio é o custo calculado segundo as regras aplicáveis a essa ordem. O total congelado é normalmente a soma do capital principal e do prémio; se houver outros custos devem ser revelados separadamente de antemão, e não se podem adicionar encargos não confirmados na liquidação.\n2.3 O saldo disponível é o saldo utilizável para novas operações segundo as regras atuais da conta. O saldo congelado é o reservado para ordens aceites ou operações aprovadas, temporariamente indisponível para outras ações. Rendimentos previstos, indemnizações pendentes de revisão, limites de nós e distribuições não contabilizadas não entram no saldo disponível. A apresentação do saldo deve indicar o nome do ativo; não é permitido somar diretamente quantidades de ativos diferentes.\n2.4 A sequência AI é o registo de operações encadeadas desde a 1.ª ordem segundo regras para o mesmo plano confirmado. O passo atual, o resultado da ordem e as provas de elegibilidade são mantidos pelo servidor. Desconexão normal ou saída da app não constituem terminação da sequência; o reset é terminar a sequência antiga após cumprir as condições deste acordo.\n2.5 O limite de nó de potência computacional é a unidade contabilística equivalente a USDT acumulada segundo regras a partir da perda qualificada final, usada para gerar nós. O nó é um registo de elegibilidade para participar em distribuições posteriores de direitos, não dinheiro imediato nem PANTA creditado, e não se torna por nomenclatura um NFT on-chain negociável, stakeable ou livremente transferível.\n2.6 O instantâneo de regras é a versão de regras, parâmetros, montantes, base de preço, cláusulas e provas relacionadas guardadas ao confirmar a ordem ou sequência. Uma nova versão publicada não pode sobrescrever instantâneos antigos. Os registos do servidor servem para verificar o estado das operações, mas o utilizador pode apresentar outras provas para solicitar revisão; não se podem excluir objeções razoáveis apenas porque os registos são guardados pela plataforma.\n\nArtigo 3: Elegibilidade de utilização e confirmação do acordo\n\n3.1 A plataforma só pode fornecer as funcionalidades correspondentes a utilizadores dentro de regiões de serviço, faixas etárias e de adequação aprovadas. A versão oficial deve especificar requisitos de verificação de identidade, âmbito de produtos disponíveis e motivos de restrição. Não se pode considerar elegível para todos os produtos apenas porque a wallet está ligada, a interface é visível ou a conta tem saldo.\n3.2 O utilizador deve utilizar contas e ativos sob o seu controlo legítimo; é proibido usurpar identidade, usar contas alheias sem autorização, falsificar documentos de elegibilidade ou manipular sinais ou provas de resultados. Se a plataforma necessitar de verificação adicional, deve explicar os documentos necessários e o propósito operacional; restrições a nova participação e cumprimento de ordens existentes devem ser explicadas separadamente.\n3.3 Antes de ordenar, o utilizador deve poder consultar capital principal, prémio, possíveis custos adicionais, opções de previsão, pior perda, condições de liquidação, fonte de determinação e via de disputa. A plataforma deve oferecer passos de confirmação claros e não substituir a confirmação real do utilizador por consentimento por defeito, custos ocultos, alteração automática de montante ou pressão para repetir operações.\n3.4 Sinais AI, resultados históricos, rendimentos de exemplo, dimensão do pool de nós e registos de direitos de terceiros não constituem promessa de resultados futuros. O utilizador pode perder o capital principal de ordens aceites e prémios relacionados; direitos de nós também podem ser afetados por saldo do pool, peso efetivo, preço e estado de processamento. O utilizador não deve tomar um exemplo concreto como rendimento fixo próprio ou prazo de recuperação determinado.\n\nArtigo 4: Regras de previsão de contrato de evento\n\n4.1 Antes de iniciar uma sequência AI, o utilizador deve rever planos disponíveis, capital principal de posição de execução, prémio estimado, necessidade total de fundos, validade do sinal, regra de liquidação de 60 segundos e condição de indemnização de 90%. Uma sequência nova só pode começar a partir da 1.ª ordem; não se pode mudar de plano durante a sequência; o utilizador não pode combinar saltos de passo, alteração de montante ou ordens pendentes em paralelo para formar nova sequência qualificada. Após escolher o resultado do evento e introduzir capital principal em JOULE, a plataforma calcula o prémio segundo a base de posição aprovada. Desenho atual: se o capital principal não exceder 10% da base de posição, o prémio é 15% do capital principal; se exceder 10%, 20%. No limite exato de 10% aplica-se 15%.\n4.2 O sinal AI deve mostrar ativo, direção, hora, validade e número de sinal identificável. Ao ordenar, o utilizador deve confirmar direção coerente com o sinal válido nesse momento. Se o sinal for atualizado durante espera ou reconexão, deve revalidar-se; sinal expirado não pode continuar a ser usado a partir de cache do cliente. Adotar sinal AI não significa que a plataforma ou o algoritmo conheçam o resultado futuro. Precisão histórica, registos demo e explicações de previsão não garantem o resultado desta ordem. A plataforma não pode usar expressões como 「vitória garantida」, 「lucro estável」 ou 「sem perda se errar」 em lugar do capital principal, prémio e condições reais de indemnização.\n4.3 Cada evento deve indicar separadamente nome, descrição factual, resultados opcionais, momentos de abertura e fecho, fuso horário, limites de participação, critérios de determinação do resultado, fontes principais e de reserva, cálculo de lucro, pior perda, regras de cancelamento ou adiamento e procedimento de reclamação. Para eventos ambíguos, sem critérios de determinação ou com parâmetros económicos essenciais não aprovados, não se pode abrir ordem real. Ao aceitar a ordem, a plataforma deve verificar que o evento permanece aberto, que a hora do servidor é anterior ao fecho, que opções e versão são válidas, que elegibilidade e limites do utilizador se cumprem e que há saldo suficiente. O fecho não se julga pela hora do dispositivo do utilizador nem por o cliente ainda mostrar contagem decrescente ao clicar.\n4.4 Após congelar com sucesso capital principal e prémio e aceitar a ordem, a plataforma devolve hora de aceitação e momento de liquidação acordado. Esse momento calcula-se como hora de aceitação do servidor mais 60 segundos, não desde abrir a página, receber o sinal ou premir o botão. A latência de rede não encurta nem prolonga o critério de determinação já fixado. 60 segundos indicam o momento acordado de determinação do resultado, sem prometer crédito de fundos no mesmo instante em que a contagem decrescente do cliente chega a zero. Ao chegar o momento, deve obter-se prova do resultado da fonte acordada; sem prova, fonte anómala ou conflito de resultados, mantém-se pendente de liquidação com explicação, sem registar automaticamente perda.\n4.5 Só quando há sequência válida atual, regras apresentadas claramente e sem ordens pendentes, e o utilizador envia efetivamente direção distinta do sinal válido ou montante distinto do passo fixo atual, aplica-se o desenho de rejeição e reset que termina a sequência antiga. Devem mostrar-se motivo concreto, sequência afetada e próxima ação executável, conservando o histórico. Após reset, na vez seguinte pode criar-se sequência nova a partir da 1.ª ordem; não se podem concatenar ordens perdidas da sequência antiga com as da nova para calcular 8 perdas consecutivas. Perdas e ganhos concluídos na sequência antiga mantêm-se e não recebem automaticamente indemnização de 90%; isso não impede solicitar revisão por erro da plataforma, reset incorreto ou outra disputa.\n4.6 O pedido infrator rejeitado não se executa e não gera nova perda de capital principal, prémio ou nó de perda. A redação em material original sobre converter perda infratora em nó ainda não formou regra executável; não pode usarse para inventar perdas ou compensações em ordens rejeitadas.\n4.7 O utilizador pausar o início de passos posteriores não equivale a ter formado 8 perdas consecutivas; sequência incompleta não pode solicitar indemnização de 90% proporcional ao número de ordens perdidas. Terminação ativa de sequência, permanência prolongada e prazos de recuperação requerem confirmação formal de regras; não se pode adicionar por conta própria prazo de caducidade não revelado. Saída normal e desconexão não se interpretam como renúncia voluntária. Uma mesma sequência deve cumprir simultaneamente estas quatro condições para calcular indemnização de 90% em JOULE segundo o desenho atual: em cada ordem o mecanismo de seguro está ativo e capital principal e prémio dessa ordem são congelados com sucesso; direção de cada ordem coerente com sinal AI válido ao aceitar; capital principal e ordem de passos de cada ordem conforme plano confirmado; as 8 ordens são totalmente liquidadas e todos os resultados são perdas qualificadas. O montante de indemnização é o total do capital principal de participação de 8 ordens qualificadas multiplicado por 90%, medido e pago em JOULE; o prémio não entra nessa base de 90%. A indemnização não pode expressar-se diretamente como devolução de 90% de todas as despesas, nem converter-se automaticamente em USDT, dinheiro ou PANTA. Troca de outros ativos requer regras e autorização independentes.\n4.8 A constituição de elegibilidade de indemnização e o pagamento bem-sucedido são duas fases. Com elegibilidade mas fundos insuficientes, anomalia contabilística ou restrições aplicáveis, conservam-se obrigação e detalhe pendentes de pagamento, mostra-se processamento ou motivo claro de suspensão, e actua-se conforme lei e contrato; não se pode reescrever dificuldade de pagamento como falta de elegibilidade do utilizador.\n4.9 A indemnização executa-se uma vez segundo o registo único dessa sequência. Se o pagamento foi bem-sucedido mas a resposta se perdeu, consultas e novas tentativas posteriores devem devolver o resultado original sem pagamento duplicado. Falha de pagamento deve manter estado real de incompleto; não se pode exigir ao utilizador criar sequência nova ou reordenar para 「ativar」 a indemnização original. Se na mesma sequência o mecanismo de confirmação prévia permitir taxas distintas por ordem, deve guardar-se instantâneo por ordem e acumular-se custo real; não se pode recalcular todas as ordens históricas com uma única taxa atual. Alterações de mecanismo tarifário que afetem sequências já confirmadas devem definir primeiro o seu âmbito; não se pode aumentar custo retroativamente mediante nova página.\n4.10 Unidade mínima de ativo, precisão, método de arredondamento por ordem e tratamento de restos devem fixar-se antes do lançamento e manter-se coerentes. Arredondamento na página para legibilidade não deve alterar detalhe contabilístico; a precisão em exemplos de cálculo não é a precisão de pagamento já aprovada. Comissões, spread e restos não podem ocultar-se mediante apresentação combinada.\n\nArtigo 5: Serviços do sistema\n\n5.1 Desconexão ou tempo de pedido esgotado: o utilizador consulta primeiro a ordem original; a plataforma devolve estado real aceite, rejeitado explicitamente ou ainda pendente de confirmação. Com resultado original desconhecido não se deve induzir pagamento duplicado; só após confirmar posteriormente não aceitação pode reconfirmar-se novo pedido segundo regras vigentes.\n5.2 Sinal ou cotação expirada: rejeitar pedido antigo, mostrar motivo e voltar a obter conteúdo. Não se pode substituir silenciosamente por nova direção, montante ou custo, nem tratar expiração automaticamente como reset por infração AI. Se o pedido antigo já foi aceite, cumpre-se segundo o seu instantâneo.\n5.3 Resultado ou preço anómalo: suspender determinação, avaliação ou distribuição afetada; fornecer estado, âmbito afetado e canal de consulta. Resultado ausente não pode registar-se como perda por falha; avaliação anómala não pode ampliar base de perda. Mudança de fonte de reserva deve seguir ordem de fontes e regras de anomalia previamente publicadas.\n5.4 Diferença contabilística ou estado de transacção externa desconhecido: verificar primeiro registo original e recibo externo; não reenviar acções irreversíveis. Após confirmar falha, descongelar ou tentar novamente segundo regras correspondentes; desconhecido não equivale a reembolso concluído. Acções de fundos do utilizador concluídas e passos posteriores de compra de moeda ou entrada no pool incompletos devem mostrar-se separadamente.\n5.5 Escassez de fundos: parar novas operações relacionadas que possam ampliar o défice, conservar obrigações já formadas, informar estado pendente e actuar segundo plano aprovado. Não se pode falsificar crédito, colocar saldo disponível em negativo nem cobrir diferença com encargos adicionais não informados.\n5.6 Restrições de risco: a plataforma pode realizar verificações ou restrições necessárias segundo regras formalmente aprovadas e devidamente reveladas, mas deve distinguir restrição de novas ordens, atraso de pagamento e cancelamento de elegibilidade. Restrições não podem reescrever automaticamente resultados históricos ou condições económicas já cumpridas; excepções requerem factos e fundamento, com canal de revisão disponível.\n5.7 Em manutenção, cessação de serviço ou encerramento de produto, devem existir disposições para ordens históricas, indemnizações, disputas e registos verificáveis. O utilizador não poder adicionar operações não implica desaparecimento de saldo existente, indemnizações devidas ou direito de reclamação. Desligar o interruptor de novas operações não deve fechar simultaneamente toda a consulta histórica e processos de cumprimento.\n\nArtigo 6: Cláusulas de isenção de responsabilidade\n\nPor perdas causadas pelas seguintes circunstâncias, o serviço não assume responsabilidade de indemnização:\n6.1 Incumprimento de estratégia: qualquer conduta que se afaste da normativa padrão de gestão de posições desta plataforma\n6.2 Condições extremas de mercado: perdas por paralisia de exchange, esgotamento de liquidez ou manipulação de mercado\n6.3 Riscos de sistema e operação: perdas por avaria do dispositivo do utilizador, erro operacional ou roubo de conta\n6.4 Riscos de política e conformidade: interrupção ou proibição de operações por alterações legais, regulamentares ou ordens regulatórias\n6.5 Risco do token intrínseco: queda acentuada ou colapso da capitalização de JOULE que afete a sua função como margem e moeda de liquidação\n6.6 Fraude e conduta maliciosa: participação do utilizador em fraude, branqueamento de capitais, manipulação de mercado ou outras actividades ilegais\n6.7 Força maior: falha do sistema desta plataforma por força maior\n\nArtigo 7: Divulgação de riscos\n\nO utilizador confirma ter compreendido plenamente e aceitar os seguintes riscos:\n7.1 Sem garantia de capital nem de lucro: este plano apenas indemniza parte das perdas e não garante absolutamente a segurança do capital nem lucros\n7.2 Risco de dependência de estratégia: o efeito de proteção depende totalmente do cumprimento rigoroso da estratégia\n7.3 Risco de liquidez e bloqueio: fundos de indemnização em conta de gestão patrimonial podem envolver risco de investimento e período de bloqueio, afectando a liquidez\n7.4 Risco de terceiros: riscos operacionais, de segurança e de flutuação de valor dos exchanges dos quais depende\n7.5 Risco de incerteza regulatória: esta plataforma enfrenta incerteza regulatória global e risco de suspensão\n7.6 Risco de segurança tecnológica: inclui risco de perda de activos por vulnerabilidades de smart contract, ataques informáticos, etc.\n\nArtigo 8: Alteração, terminação e disputas do acordo\n\n8.1 Alteração do acordo: esta plataforma reserva-se o direito de rever este acordo conforme lei ou necessidades operacionais; alterações importantes serão notificadas mediante anúncio da plataforma\n8.2 Terminação do acordo: o utilizador pode desactivar o interruptor de protecção a qualquer momento para terminar o serviço; se violar o acordo, a plataforma pode terminar unilateralmente; por motivos legais ou de política este plano pode terminar-se\n8.3 Resolução de disputas: disputas decorrentes deste acordo resolver-se-ão mediante negociação amigável; se falhar, serão submetidas ao organismo arbitral ou tribunal designado\n\n【Confirmação final】Compreende e concorda que 「Activar o interruptor de seguro」 é a única e definitiva forma de confirmar que fica vinculado por todo o conteúdo deste acordo; tome a decisão com juízo independente.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "Conectar",
    inputPlaceholder: "Digite o endereço",
    bind: "Vincular",
    binding: "Vinculando",
    tip: "Dica: Se a conexão da carteira falhar, você pode tentar inserir manualmente o endereço da carteira para vincular"
  },
  loginModal: {
    title: "Login to PANTA MARKET",
    connectWallet: "Conectar",
    connecting: "Conectando...",
    alreadyConnected: "Conectado",
    tip: "Dica: Se a conexão da carteira falhar, você pode tentar inserir manualmente o endereço da carteira para vincular",
    inputLabel: "Digite o endereço da carteira",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Vincular",
    binding: "Vinculando",
    bindSuccess: "Vinculação bem-sucedida",
    bindSuccessHint: "Vinculação bem-sucedida, faça login novamente",
    bindFailed: "Vinculação falhou",
    noAuthCode: "Código de autorização ausente",
    invalidAddress: "Formato de endereço de carteira inválido",
    confirmTitle: "Confirmar vinculação",
    confirmWarning: "Por favor, confirme cuidadosamente que o seguinte endereço é o endereço da sua carteira. Não pode ser alterado após a vinculação",
    addressLabel: "Endereço da carteira",
    cancel: "Cancelar",
    confirm: "Confirmar vinculação",
    loginSuccess: "Login bem-sucedido",
    openWalletApp: "Abrir {wallet}",
    openWalletConnect: "Abrir {wallet} para conectar",
    openWalletSign: "Abrir {wallet} para assinar",
    returnToBrowser: "Volte aqui quando terminar",
    loginStepLabel: "Etapa {step}/2",
    stepConnectTitle: "Conectar carteira",
    stepConnectHint: "Aprove a conexão na sua carteira e volte aqui",
    stepConnectHintWithOpen: "Toque abaixo para abrir a carteira, aprove a conexão e volte aqui",
    stepSignTitle: "Entrar",
    stepSignHint: "Assine a mensagem de login na carteira (não move fundos) e volte aqui",
    stepSignHintWithOpen: "Mais um passo: toque abaixo para abrir a carteira e assinar a mensagem",
    waitingWalletHintShort: "Se não abriu, toque abaixo para abrir a carteira",
    retryLogin: "Tentar login novamente",
    networkRequired: "Trocar rede",
    networkRequiredHint: "Mude para {chain}, volte aqui e tente novamente",
    switchingNetwork: "Confirmar troca de rede",
    switchingNetworkHint: "Aprove a troca para {chain} na sua carteira",
    signatureRequired: "Assine para entrar",
    signatureHint: "Assine na carteira — isso não transfere fundos",
    verifyingLogin: "Verificando",
    verifyingHint: "Aguarde um momento",
    connectFailed: "Conexão incompleta, tente novamente",

    waitingWalletReturn: "Autorize no aplicativo da carteira e volte aqui",
    waitingWalletHint: "Autorize na carteira; você voltará automaticamente"
  },
  walletProfile: {
    title: "Perfil",
    address: "Endereço",
    accountName: "Nome da Conta",
    inviteCode: "Código de Convite",
    deactivateAccount: "Desativar Conta",
    logout: "Sair",
    switchAccount: "Trocar Conta",
    confirmLogout: "Tem certeza de que deseja sair?",
    loggingOut: "Saindo...",
    confirmSwitch: "Tem certeza de que deseja trocar de conta? A conta atual será desconectada",
    developing: "Em Desenvolvimento",
    addressCopied: "Endereço Copiado",
    inviteCodeCopied: "Código de Convite Copiado"
  },
  aiPrediction: {
    stakeAutofill: "Assistência IA",
    stakeAutofillWarning: "Apenas assistência. O valor sugerido pode estar errado; confira antes de enviar. O preenchimento automático pausa se a latência passar de 800 ms ou a verificação falhar/expirar, e retoma na recuperação. Pedidos manuais não são afetados.",
    stakeAutofillUnavailable: "Conexão instável ou acima de 800 ms. Ainda não é possível ativar.",
    stakeAutofillPaused: "Preenchimento automático pausado: conexão instável. Digite o valor manualmente.",
    insuranceSyncing: "Sincronizando etapa do seguro…",
    predictionBuffer: 'Preparando a próxima previsão',
    scheduleResultPending: 'Resultado indisponível, tentando novamente',
    title: "Previsão IA",
    bookingTitle: "Reserva de sessões AI",
    bookingExpand: "Expandir",
    bookingCollapse: "Recolher",
    bookingNextSystem: "Próxima sessão · SGT",
    bookingNextMine: "Minha próxima reserva",
    bookingNone: "Nenhuma",
    bookingStartingSoon: "Sua sessão reservada começa em breve",
    bookingToday: "Hoje",
    bookingTomorrow: "Amanhã",
    bookingTimezone: "SGT",
    bookingQuota: "Sessões restantes: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} vagas",
    bookingEmpty: "Nenhuma sessão disponível",
    bookingWaiting: "Entrará automaticamente ao terminar a operação atual",
    bookingEnded: "Encerrada",
    bookingJoin: "Entrar na sessão",
    bookingReserve: "Reservar",
    bookingJoined: "Entrou",
    bookingReserved: "Reservado",
    bookingFull: "Lotado",
    bookingConfirm: "Confirmar reserva",
    bookingWarning: "Uma reserva bem-sucedida usa 1 sessão do dia; conta mesmo se não comparecer.",
    bookingQuotaExhausted: "Você usou todas as sessões disponíveis hoje",
    bookingUnavailable: "Reserva indisponível no momento",
    bookingFailed: "Falha na reserva. Atualize e tente novamente.",
    aiPool: "Pool AI",
    countdown: "Contagem Regressiva",
    expectedProfit: "Lucro Esperado",
    active: "Ativo",
    aiAnalysis: "Análise Inteligente de Probabilidade de Alta/Baixa",
    updateTime: "Hora de Atualização",
    probabilityUp: "Probabilidade de Alta",
    probabilityDown: "Probabilidade de Baixa",
    startPrediction: "Iniciar Previsão",
    predicting: "Prevendo...",
    stayOnPageHint: "Não saia desta página, senão o resultado da previsão pode ser perdido.",
    userInfo: "Info do Usuário",
    predictCount: "Contagem de Previsões",
    freeCount: "Previsões Gratuitas",
    openTime: "Abre às: {time1}",
    up: "Alta",
    down: "Baixa",
    notConnected: "Não Conectado",
    count: "Contagem",
    learnMore: "Saiba Mais",
    calculating: "Calculando...",
    settled: "Liquidado",
    loginFirst: "Por favor, faça login primeiro",
    sessionSyncing: "Sincronizando",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Posições",
      history: "Histórico",
      empty: "Sem posições",
      historyEmpty: "Sem histórico",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Comprar Privilégio",
      description: "Comprar 30 Previsões IA",
      upgradeAmount: "Valor do Upgrade",
      balance: "Saldo Disponível",
      cancel: "Cancel",
      confirm: "Confirmar",
      purchasing: "Comprando...",
      purchaseSuccess: "Compra Bem-sucedida",
      purchaseFailed: "Compra Falhou",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "Falha na Previsão IA",
      description: "Sua contagem de previsões IA é 0. Você não pode usar a previsão IA no momento. Por favor, compre para continuar.",
      cancel: "Cancelar",
      confirm: "Comprar Previsão IA"
    },
    toasts: {
      predictionFailed: "Previsão falhou",
      predictionSuccess: "Previsão concluída",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Analisando...",
    insurance: "Seguro",
    insuranceOn: "Ativo",
    insuranceOff: "Inativo",
    aiLabel: "AI",
    lookLong: "Alta",
    lookShort: "Baixa",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Seguir esta ronda",
    scheduleBinding: "A vincular sinal...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "Preço de abertura",
    settledAt: "Liquidado em",
    ordinaryInsuranceTitle: "Este pedido usa seguro comum",
    ordinaryInsuranceBody: "Este pedido é seguro comum, não um pagamento de rodada de IA. O prêmio segue a prévia após confirmar.",
    sessionConflict: "Há uma rodada de seguro de IA em andamento. Restaure ou encerre antes do seguro comum.",
    conversionTitle: "Converter para seguro ordinário?",
    conversionDesc: "Este pedido passará para seguro ordinário e encerrará a rodada de seguro IA. Sequências de perdas IA anteriores não serão pagas. Prêmio ordinário {premium} JOULE.",
    conversionConfirm: "Confirmar conversão e ordem",
    stakeFromStrategy: "Tamanho definido pela estratégia",
    stakeTier: "Nível {tier}",
    stakeStep: "Passo {step}",
    selfQuotaRemaining: "Autopredição restante: {remaining}/{limit}",
    followRoundProgress: "Seguir IA · Rodada {current}/{total}",
    followRoundsCompleted: "Seguir IA concluído · {current}/{total}",
    selfQuotaLoadingShort: "Carregando cota…",
    selfQuotaLoginHint: "Faça login para ver a cota",
    selfQuotaLoading: "Cota carregando, tente mais tarde",
    selfQuotaExhausted: "Cota grátis de autopredição esgotada hoje; predição paga ainda não aberta"
  },
  positionModal: {
    title: "Previsão de preço",
    insurance: "Seguro",
    long: "Compra",
    short: "Venda",
    balance: "Saldo",
    loading: "Carregando...",
    confirm: "Confirmar",
    processing: "Processando pedido...",
    success: "Pedido realizado com sucesso!",
    insuranceOn: "Seguro ativado",
    insuranceOff: "Seguro desativado",
    operationFailed: "Operação falhou",
    balanceFetchFailed: "Falha ao obter saldo",
    minAmount: "Valor mínimo é 0.1 TAKER",
    insufficientBalance: "Saldo insuficiente, saldo atual: {balance} TAKER",
    createFailed: "Falha ao criar posição",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  assets: {
    insuranceFrozen: "Limite Congelado do Seguro (JOULE)",
    available: "Disponível",
    deposit: "Depósito",
    withdraw: "Retirada",
    myAccountRecords: "Registros da Minha Conta",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Congelamento da aposta",
      WIN_PAYOUT: "Lucro da negociação",
      LOSS_SETTLEMENT: "Prejuízo da negociação",
      REFUND: "Reembolso",
      INSURANCE_PREMIUM: "Despesa de prêmio",
      INSURANCE_PAYOUT: "Indenização do seguro",
      INSURANCE_TRANSFER_IN: "Transferência de entrada do seguro",
      INSURANCE_TRANSFER_OUT: "Transferência de saída do seguro",
      NETWORK_DIFFERENTIAL: "Bônus diferencial de negociação",
      NETWORK_PEER: "Bônus de nível igual",
      NETWORK_UNLOCK: "Desbloqueio de ganhos",
      EVENT_INSURANCE_PAYOUT: "Pagamento do nó de computação",
      EVENT_INSURANCE_PEER: "Bônus de nível igual de computação",
      TRANSFER_IN: "Entrada",
      TRANSFER_OUT: "Saída",
      PREMIUM_LOCK: "Bloqueio do prêmio",
      PREMIUM_SETTLE: "Despesa de prêmio",
      PREMIUM_REFUND: "Reembolso do prêmio",
      WEALTH_SUBSCRIPTION: "Subscrição do fundo",
      SUBSCRIPTION_LOCK: "Bloqueio de staking",
      WEALTH_DAILY_REWARD: "Juros diários do fundo",
      WEALTH_TEAM_REWARD: "Bônus de equipe do fundo",
      MATURITY_RELEASE: "Devolução do principal no vencimento",
      WEALTH_UNLOCK: "Desbloqueio de ganhos",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "P&L da negociação",
      PREMIUM: "Prêmio",
      INSURANCE_PAYOUT: "Indenização",
      TEAM_REWARD: "Bônus de equipe",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Juros do fundo",
      UNLOCK: "Desbloqueio",
      PRINCIPAL: "Assinatura/retorno",
      TRANSFER: "Transferência interna"
    },
    amountPendingReview: "Valor pendente de revisão",
    creditedSplit: "Disponível {available} · Congelado {frozen}",
    creditedSplitPending: "Divisão pendente de revisão",
    afterBalance: "Após: disponível {available} · congelado {frozen}",
    unlockHint: "Congelado → disponível; não é novo ganho",
    transferFromInsurance: "Conta de seguro",
    transferFromMain: "Conta principal",
    all: "Tudo",
    transfer: "Transferência",
    insuranceDeduction: "Dedução de Seguro",
    insurancePayout: "Pagamento de Seguro",
    noRecords: "Sem registros",

    actions: {
      deposit: "Depósito",
      withdraw: "Retirada",
      exchange: "Troca",
      transfer: "Transferência"
    },
    loginPrompt: {
      text: "Por favor, conecte sua carteira primeiro",
      button: "Conectar"
    },
    toasts: {
      connectFailed: "Conexão falhou, por favor tente novamente"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "Copy",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "Conta copy (JOULE)",
    copyTotalPnl: "PnL copy",
    transferSheet: {
      title: "Transferir",
      pairCopy: "Trading / Copy",
      pairInsurance: "Trading / Seguro",
      tradingAccount: "Conta de trading",
      copyAccount: "Conta de copy",
      insuranceAccount: "Conta de seguro",
      jouleHint: "Somente transferências JOULE",
      submit: "Enviar",
      transferring: "Transferindo...",
      success: "Transferência concluída",
      failed: "Falha na transferência, tente novamente",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "Este valor é o principal em stake mais os ganhos estimados.",
    stakedPrincipalLabel: "Principal em stake",
    stakedExpectedYieldLabel: "Ganhos estimados",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Recompensas da equipe pendentes (PANTA)",
    fundTeamPaidPanta: "Recompensas da equipe pagas (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Valor acumulado de airdrops: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  appeal: {
    title: "Assistência de Auditoria de Ativos",
    records: "Registros de Envio",
    recordsTitle: "Registros de Envio",
    noRecords: "Sem registros de envio",
    submitTime: "Hora de Envio",
    statusPending: "Pendente",
    statusApproved: "Aprovado",
    statusRejected: "Rejeitado",
    failedReason: "Motivo da Rejeição",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Carregando...",
    walletAddress: "Endereço vinculado ao PANTA MARKET",
    address: "Endereço",
    walletAddressPlaceholder: "Digite o endereço de login do PANTA MARKET",
    autoFill: "Preenchimento automático",
    depositAmount: "Valor do depósito",
    depositAmountPlaceholder: "Digite o valor do depósito",
    tokenType: "Tipo de token",
    selectToken: "Selecione o token",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Hora da transferência",
    selectTime: "Selecione a hora da transferência",
    timeRangeHint: "Dados relevantes gerados entre 5 de março de 2026 00:00 e 11 de março 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Digite o hash da transação",
    txHashHint: "Pode ser consultado no explorador de blockchain",
    uploadImages: "Captura de tela do registro de transferência",
    uploadHint: "Opcional, carregue até 9 imagens",
    addImage: "Adicionar imagem",
    submit: "Enviar",
    submitting: "Enviando...",
    submitSuccess: "Enviado com sucesso",
    submitFailed: "Falha no envio, tente novamente",
    uploadingImages: "Enviando imagens...",
    uploadImagesFailed: "Falha ao enviar imagens",
    warningTitle: "Aviso importante",
    warningText: "Se o registro enviado for verificado com sucesso, você receberá uma recompensa de 5% do poder de assinatura. Se informações falsas forem fornecidas, a conta será congelada."
  },
  withdrawSheet: {
    title: "Retirar",
    balance: "Saldo",
    processing: "Retirando TAKER...",
    success: "Retirada de TAKER bem-sucedida!",
    withdrawing: " retirando...",
    withdrawSuccess: " Enviado para revisão",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "Depositar TAKER",
    depositTo: "Depositar em",
    spotAccount: "Conta Spot",
    network: "Rede",
    networkWarning: "Apenas depósitos via rede BSC/BEP20 são suportados. Perdas de ativos causadas pelo uso de outras redes não podem ser recuperadas.",
    depositAddress: "Endereço de depósito",
    address: "Endereço",
    depositTAKER: "Depositar TAKER",
    recharge: "Recarregar",
    rechargeAddress: "Endereço de recarga",
    copy: "Copiar",
    copySuccess: "Copiado com sucesso",
    loadingAddress: "Obtendo endereço de recarga...",
    loadAddressFailed: "Falha ao obter endereço de recarga",
    clickToRetry: "Clique para tentar novamente",
    saveAndShare: "Salvar e compartilhar endereço",
    generating: "Gerando...",
    generateSuccess: "Gerado com sucesso",
    generateFailed: "Falha ao gerar",
    more: "Mais",
    save: "Salvar",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Imagem salva",
    download: "Baixar",
    pleaseGenerate: "Por favor, gere a imagem primeiro",
    downloadSuccess: "Download bem-sucedido",
    saveSuccess: "Salvo com sucesso",
    saveFailed: "Falha ao salvar",
    needPermission: "Permissão necessária para salvar imagem no álbum",
    pleaseUseDapp: "Por favor, use a carteira para abrir a operação dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "Fazer login na conta",
    inviteBanner: "Convide amigos e ganhe comissões de equipe",
    inviteCode: "Código de convite",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "Minhas indicações",
    currentLevel: "Nível atual: {level}",
    nextLevel: "Próximo nível",
    totalMembers: "Referências diretas",
    validMembers: "Membros válidos",
    teamLevel: "Nível da equipe: {level}",
    tradeTeam: "Equipe de negociação",
    financeTeam: "Equipe financeira",
    teamMembers: "Membros da equipe",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "Diretos de {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "Lucro total",
    totalFlow: "Fluxo total",
    totalInvites: "Total de convites",
    validMembers: "Total de membros válidos"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "Novo chat",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Olá, sou seu assistente de IA",
    hint: "Pergunte sobre mercados, onde ver regras de seguro de evento/AI, equipe e convite, ou risco.",
    placeholder: "Pergunte algo...",
    send: "Enviar",
    thinking: "Analisando...",
    disclaimer: "Apenas referência — não é aconselhamento de investimento.",
    bullish: "Alta",
    bearish: "Baixa",
    aiAnalysis: "Resumo IA",
    strategy: "Estratégia",
    reasoning: "Raciocínio",
    targetPrice: "Alvo {price}",
    stopLoss: "Stop {price}",
    takeProfit: "Gain {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "Neutro",
    analysisDone: "Análise de {symbol} ({timeframe}) pronta. Veja o cartão abaixo.",
    analysisBtc: "Análise de curto prazo do BTC.",
    analysisEth: "Análise de intervalo do ETH.",
    analysisRisk: "Leitura de risco de mercado.",
    suggestions: {
      btc1m: "Analisar outlook BTCUSDT 1m",
      ethTrend: "Devo perseguir ETH ou esperar?",
      marketRisk: "Qual o apetite a risco atual?",
      eventRules: "Onde ver o resumo das regras de seguro do contrato de evento?",
      aiRules: "Como entender regras/níveis da previsão AI?",
      teamWhere: "Onde ver detalhes da equipe?",
      inviteWhere: "Onde está o link de convite / vincular superior?"
    },
    guides: {
      eventRules: "Regras de seguro do evento: abra Event Contract e o atalho de regras ao lado do switch. Prévia para prêmio/limites/benefícios; Acordo completo para o texto legal.",
      aiRules: "AI Prediction: aba central → AI Prediction. Veja countdown da próxima rodada, nível/passo do seguro e cota de autoprevisão. Regras na mesma ficha de seguro. Ordens devem bater tamanho e direção do nível.",
      teamWhere: "Detalhes da equipe: barra lateral ou Eu → Minha equipe. Alterne ganhos de trade/finanças e abra Detalhes da equipe para indicados, volume, nível e membros.",
      inviteWhere: "Convite e vínculo: barra lateral/Eu → Convidar amigos para copiar o link (?ref=). Sem superior vinculado, o modal aparece após login. Sem parâmetro de convite, o campo pré-preenche o endereço padrão do env."
    },
    generic: {
      a: "Entendi. Pergunte sobre mercados, onde ficam as regras de evento/AI, equipe e convite, ou use os atalhos.",
      b: "OK. Cartões de outlook e atalhos de recursos.",
      c: "Tente regras de evento, regras AI, detalhes da equipe ou link de convite."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "Negociações recentes",
    tabLp: "LP",
    tabPositions: "Posições",
    tabRules: "Regras",
    colAddress: "Endereço",
    colTime: "Hora",
    colType: "Tipo",
    colVolumePrice: "Tamanho/Preço",
    colTurnover: "Notional",
    typeBuy: "Compra",
    typeSell: "Venda",
    empty: "Sem dados",
    share: "Compartilhar",
    rulesBody: "Este mercado é uma previsão binária de evento. O livro pode travar antes da liquidação; após o resultado, liquida conforme a posição. Atenção aos riscos.",
    priceJoule: "Preço (JOULE)",
    investJoule: "Investimento (JOULE)",
    totalLiquidity: "Liquidez",
    dealPrice: "Preço de preenchimento",
    estProfit: "Lucro est.",
    jouleBalance: "Saldo JOULE: {n}",
    positionCount: "Posições: {n}",
    max: "Máx",
    confirmOrder: "Confirmar ordem",
    ordering: "Enviando...",
    enterAmount: "Informe o valor",
    invalidPrice: "Preço inválido",
    amountExceed: "Excede o saldo",
    orderSuccess: "Ordem enviada",
    poolSize: "Tamanho do pool",
    colBalance: "Saldo",
    shares: "{n} unidades",
    rulesTitle: "Regras",
    rulesValue: "Sem descrição",
    settleSource: "Fonte de liquidação",
    settleValue: "Sem descrição"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "Token de governança PANTA",
    todayBurn: "Queimado hoje",
    totalBurn: "Total queimado",
    burned: "Queimado",
    initialSupply: "Emissão inicial",
    maxSupply: "Emissão máxima",
    finalCirculation: "Circulação final",
    contractAddress: "Contrato: ",
    copied: "Copiado",
    ecoSection: "PANTA · Ecossistema AI",
    ecoTabs: {
      market: "Análise de mercado",
      arbitrage: "Ferramentas de arbitragem",
      acquisition: "Aquisição global",
      video: "Criação de vídeo"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Grupos criativos",
    groupTabs: {
      recommend: "Para você",
      hot: "Popular",
      ipDrama: "Drama IP",
      ipCollab: "Co-criação IP",
      data: "Dados"
    },
    filters: {
      all: "Todos",
      new: "Lançamentos",
      ending: "Terminando",
      highScore: "Alta nota AI"
    },
    project: {
      badge: "Estreia no Planet",
      title: "《Panta AI · Ascensão》 Curta animada de IA",
      score: "Nota AI 92",
      tagDrama: "Drama IP",
      tagRights: "Direitos #0001",
      desc: "Panta AI me ajuda a virar o jogo — curta tutorial de apps AI"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4.212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Copy trading",
    pageTitle: "Copy trading",
    fallback: "A operação falhou. Tente novamente mais tarde.",
    pauseRule: "Se ainda estiver pausado quando a liquidação desta semana for concluída, a relação de cópia será cancelada automaticamente na próxima semana.",
    pauseSuccess: "Pausado com sucesso",
    resumeSuccess: "Retomado",
    endSuccess: "Encerrado",
    followSuccess: "Cópia iniciada",
    pendingReviewToast: "Aguardando revisão do trader",
    savedSuccess: "Salvo",
    registerSuccess: "Registrado. Depósito congelado.",
    cancelRequested: "Cancelamento solicitado",
    cancelWithdrawn: "Cancelamento retirado",
    kickedSuccess: "Removido",
    approvedSuccess: "Aprovado",
    rejectedSuccess: "Rejeitado",
    filledToForm: "Preenchido no formulário de follow",
    traderNotFound: {
      search: "Trader não encontrado. Verifique o endereço da carteira ou ele ainda não ativou o copy trading.",
      business: "Este trader está indisponível no momento"
    },
    tabs: {
      board: "Ranking",
      follows: "Meus follows",
      join: "Seguir",
      trader: "Liderar",
      apps: "Solicitações",
      fans: "Seguidores",
      rules: "Regras",
      settings: "Regras",
      follow: "Seguir"
    },
    ui: {
      refresh: "Atualizar",
      search: "Buscar",
      loginWallet: "Conectar carteira",
      needLoginAction: "Esta ação exige login na carteira, igual ao envio de ordens.",
      needLoginTrader: "As APIs de trader exigem login.",
      loginToView: "Faça login para ver",
      loading: "Carregando…",
      empty: "Nenhum",
      readonly: "somente leitura",
      yes: "Sim",
      no: "Não",
      immediate: "efeito imediato",
      current: "Atual",
      nextWeek: "Próxima semana",
      pause: "Pausar",
      resume: "Retomar",
      end: "Encerrar",
      save: "Salvar",
      kick: "Remover",
      approve: "Aprovar",
      reject: "Rejeitar",
      requestCancel: "Solicitar cancelamento",
      withdrawCancel: "Retirar cancelamento",
      confirmFollow: "Confirmar follow",
      registerWithDeposit: "Congelar depósito e registrar",
      registerConfirmTitle: "Confirmar registro",
      registerFreezeConfirm: "{amount} JOULE de margem serão congelados na conta de trading.",
      platformSettings: "Configurações da plataforma",
      settingsTip: "Somente ordens ordinárias com seguro são copiadas. Ordens ordinárias sem seguro e ordens AI não são copiadas, e ordens COPY geradas não geram novas cópias. Traders usam a API de ordens existente e não devem passar orderSource. Seguidores veem ordens COPY na lista. Valores exibem 2 decimais; o restante é truncado.",
      deposit: "Depósito",
      depositFreezeWeeks: "Semanas de congelamento do depósito",
      maxFollowers: "Limite de seguidores",
      shareRateRange: "Faixa de taxa de repasse",
      shareRateDefault: "Taxa de repasse padrão",
      shareRateNextWeek: "Taxa de repasse entra em vigor na próxima semana",
      pendingShareHint: "Válido na próxima segunda: {rate}",
      pendingMaxFollowersHint: "Válido na próxima segunda: {n}",
      depositFrozenShort: "Ainda congelado",
      minFollowStake: "Stake mínimo de follow",
      ratioRange: "Faixa de proporção",
      maxSimultaneousFollows: "Máximo de follows simultâneos",
      defaultReview: "Revisão padrão",
      defaultMinBalance: "Limite de saldo padrão",
      settlementTimezone: "Fuso horário de liquidação",
      leaderboardMeta: "Mín. do ranking / tamanho",
      leaderboardMetaValue: "{min} ordens / {size} linhas",
      weekLeaderboard: "Ranking de taxa de acerto desta semana",
      expertLeaderboard: "Ranking de traders",
      heroTitle: "Torne-se um trader líder",
      heroDesc: "Comece a liderar trades e ganhe repasse de lucro",
      heroActiveTitle: "Você é um trader líder",
      heroActiveDesc: "Seu status de trader líder está ativo",
      heroRegister: "Registrar",
      heroSettings: "Configurações de liderança",
      myLeading: "Minha liderança",
      winRateBoard: "Taxa de acerto",
      pnlBoard: "Lucro",
      searchAddress: "Buscar endereço",
      searchNicknameOrAddress: "Pesquisar apelido ou endereço",
      searchQueryTooShort: "Digite pelo menos 2 caracteres",
      winRateShort: "Taxa de acerto",
      followersLabel: "Seguidores:",
      shareRateLabel: "Taxa de repasse:",
      roundPnlLabel: "PnL da rodada:",
      settledOrders: "{n} liquidadas",
      activeCount: "Em andamento",
      followStatsShort: "Pool {pool} · Retido {cash}",
      traderSettings: "Configurações de liderança",
      confirmChanges: "Confirmar alterações",
      confirmCancel: "Confirmar cancelamento",
      cancelModalTitle: "Aviso de cancelamento",
      activeInProgress: "Em andamento",
      leadingFollowerCount: "Seguidores {n}",
      auditApps: "Solicitações {n}",
      leaderboardNote: "Conta apenas ordens ordinárias com seguro ganhas/perdidas liquidadas desta semana, após o mínimo de ordens. Não é taxa histórica nem de AI. Nome de equipe e volume acumulado de follow não são fornecidos.",
      weekStart: "Início da semana (seg.): {date}",
      leaderboardEmpty: "Ainda não há traders no ranking. Busque o endereço completo para seguir.",
      winRate: "Acerto {n}%",
      boardSub: "Repasse {share} · Seguidores {followers}/{max} · Liquidadas {orders} · PnL semanal {pnl} JOULE",
      searchTrader: "Buscar trader",
      walletPlaceholder: "Endereço completo da carteira 0x…",
      address: "Endereço",
      status: "Status",
      shareRate: "Taxa de repasse",
      review: "Revisão",
      minBalance: "Limite de saldo",
      followerCount: "Seguidores",
      startFollow: "Começar a seguir",
      traderWallet: "Endereço do trader",
      followMode: "Modo de follow",
      ratioLabel: "Proporção (%), faixa {min} ~ {max}",
      insuranceMode: "Modo de seguro",
      takeProfit: "Take profit (JOULE, opcional)",
      stopLoss: "Stop loss (JOULE, opcional)",
      takeProfitPh: "Pausar quando o PnL líquido semanal atingir isso",
      stopLossPh: "Pausar quando a perda líquida semanal atingir isso",
      followHint: "Você pode seguir no máximo {n} trader(s) ao mesmo tempo. No limite, seguir alguém novo encerra a relação atual primeiro — não é uma prévia sem efeito. Para mudar parâmetros, encerre e siga novamente.",
      endConfirm:
        "Encerrar a relação de copy trading com este trader? Você deixará de seguir os sinais dele. Ordens históricas e PnL liquidado não são afetados.",
      weeklyPoolHint: "O pool é desta semana, não o volume acumulado de follow. Relações encerradas e solicitações pendentes não estão nesta lista.",
      networkUnclear: "Resultado não confirmado. Atualize e verifique a relação atual ou o perfil do trader antes de tentar de novo.",
      myFollows: "Meus follows",
      noFollows: "Sem relações de follow",
      followSub: "{mode}{ratio} · {insurance} · Repasse bloqueado {share}",
      followStats: "PnL semanal {pnl} · Pool {pool} · Retido {cash}",
      pauseReason: "Motivo da pausa: {reason}",
      registerTrader: "Registrar como trader",
      registerHint: "Registro: pague {amount} JOULE como depósito de trader líder (congelado enquanto ativo; reembolsado após revisão de cancelamento). Uma identidade de trader por carteira.",
      registerBalanceHint: "Após congelar o depósito de {deposit} JOULE, o saldo disponível ainda deve ser ≥ {remain} JOULE.",
      shareRateInput: "Taxa de repasse (%) faixa {min} ~ {max}; alterações entram no próximo ciclo.",
      maxFollowersInput: "Limite de seguidores (≤ {max})",
      reviewMode: "Método de aprovação",
      minBalanceInput: "Limite de saldo do seguidor · opcional (JOULE)",
      myTrader: "Meu perfil de trader",
      depositHeld: "{amount} / congelado {held}",
      currentFollowers: "Seguidores atuais",
      cancelEffective: "Cancelamento efetivo em",
      depositRelease: "Liberação do depósito em",
      editParams: "Editar configurações",
      editHint: "Repasse / limite entram na próxima semana; revisão e limite entram imediatamente. O bloqueio de liquidação é dom. 22:00 até antes de seg. 01:00 (SGT). Confie no servidor; não retome edições na seg. 00:00 por conta própria.",
      shareRatePercent: "Taxa de repasse (%)",
      minBalanceJoule: "Limite de saldo (JOULE)",
      cancelTip: "Após o cancelamento você ainda lidera esta semana; a identidade termina na próxima segunda 00:00; o depósito fica congelado mais uma semana e depois retorna. Você pode retirar antes de entrar em vigor.",
      followers: "Seguidores",
      followerSub: "{mode}{ratio} · PnL semanal {pnl} · Retido {cash}",
      applications: "Solicitações pendentes",
      noApplications: "Sem solicitações",
      fillForm: "Preencher formulário de follow",
      needTraderFirst: "Registre-se como trader primeiro",
      cancelRequestedAt: "Cancelamento solicitado em",
      ratioRangeInvalid: "A proporção deve estar entre {min} e {max}",
      shareRangeInvalid: "A taxa de repasse deve estar entre {min} e {max}",
      maxFollowersInvalid: "O limite de seguidores não pode exceder {max}",
      needShareRate: "Informe a taxa de repasse",
      needMaxFollowers: "Informe o limite de seguidores",
      needRatio: "Informe a proporção",
      badTakeProfit: "Valor de take profit inválido",
      badStopLoss: "Valor de stop loss inválido",
      badMinBalance: "Limite de saldo inválido",
      insuranceShortFollow: "Seguir",
      insuranceShortOn: "Sempre ativo",
      insuranceShortOff: "Sempre inativo",
      symbolSettings: "Configurações de símbolos de cópia",
      symbolPickHint: "tudo desligado por padrão; ligue manualmente, editável a qualquer momento",
      followSymbolHint: "Escolha entre os símbolos permitidos por este trader. Ative pelo menos um.",
      followSymbolWait: "Busque um trader primeiro e depois escolha os símbolos para seguir.",
      symbolNeedOne: "Ative pelo menos um símbolo",
      symbolNotAllowed: "Um símbolo selecionado não é permitido por este trader",
      effectiveSymbols: "Efetivos",
      editSymbols: "Editar símbolos",
      allowedSymbols: "Símbolos abertos",
      weekPnlLabel: "PnL da semana:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Cripto",
      categoryCommodity: "Commodities",
      categoryEquity: "Ações",
      symbolListCol: "Lista",
      symbolLeadCol: "Liderar",
      symbolFollowCol: "Seguir",
      symbolTags: "Aberto",
      leadingSymbols: "Símbolos liderados",
      detail: "Detalhes",
      enabled: "Ativado",
      disabled: "Desativado",
      held: "Aberto",
      notHeld: "Fechado",
      weekSettledOrders: "Liquidadas na semana",
      historicalNetPnl: "PnL histórico",
      copyTotalPnl: "PnL total copy",
      historicalSharePayout: "Repasses pagos",
      allOrders: "Todas",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Abertas",
      settledOrdersTab: "Liquidadas",
      colInterval: "Duração",
      colOrderTime: "Hora da ordem",
      colSelfPnl: "PnL próprio (c/ prêmio)",
      colEstShare: "Repasse est. (JOULE)",
      traderOrdersTitle: "Ordens líder de {symbol}",
      followOrdersTitle: "Ordens de cópia de {symbol}",
      selfPnl: "PnL próprio",
      estimatedShare: "Repasse est.",
      inProgress: "Em andamento",
      followAssets: "PnL por ativo",
      byAsset: "Por ativo",
      followHistory: "Encerradas",
      followStartTime: "Início: ",
      followEndTime: "Fim: ",
      myPendingApps: "Pendentes",
      cashHeldHint: "Repasse est. retido esta semana {cash} JOULE",
      cashHeldFrozen: "Dedução est. de repasse nesta rodada: {cash} (JOULE, congelado)",
      followedTrader: "Trader",
      followInfo: "Info de follow",
      totalPnlJoule: "PnL total (JOULE)",
      colTrader: "Trader",
      colPrincipal: "Principal",
      colPnlShare: "PnL (c/ prêmio) / repasse (JOULE)",
      traderInfo: "Perfil do trader",
      traderNotFound: "Trader não encontrado",
      followSettingsRelationHint: "Modo de follow, seguro e TP/SL valem para toda a relação e todos os símbolos selecionados. Altere a qualquer momento em Configurações de follow.",
      followSettingsPrepareHint: "Ao confirmar, esta configuração será usada em todos os símbolos que você ativar.",
      followOptions: "Opções de follow",
      noFollowOptions: "Sem opções de follow~",
      symbolFollowing: "Seguindo",
      symbolPaused: "Pausado",
      symbolIdle: "Não seguindo",
      cancelFollowSymbol: "Deixar de seguir",
      cancelSymbolConfirm: "Deixar de seguir {symbol}?",
      cancelLastSymbolConfirm: "Este é o último símbolo. Deixar de seguir encerrará toda a relação. Continuar?",
      followNow: "Seguir agora",
      followAll: "Seguir",
      unfollowAll: "Cancelar follow",
      unfollowAllConfirm: "Deixar de seguir todos os símbolos deste trader? Isso encerrará toda a relação de cópia.",
      followSettings: "Configurações",
      goFollowSettings: "Abrir ›",
      copyAccountBalance: "Conta copy: {amount} JOULE",
      orderFollowerCount: "Seguidores nesta ordem",
      copyingStatus: "Copiando",
      roleStatusLeading: "Liderando",
      roleStatusFollowing: "Copiando",
      roleStatusPaused: "Cópia pausada",
      copyOrderTag: "Copy",
      copyOpenPositions: "Posições copy abertas",
      copyInsuredOrdinary: "Seguro ordinário ativo",
      copyUninsured: "Sem seguro",
      addSymbolHint: "Este símbolo será adicionado ao seu follow atual.",
      myRelationStatus: "Meu follow",
      latestSettlements: "Últimas liquidações",
      resumeRelationFirst: "A relação está totalmente pausada. Retome em Meus follows antes de ações por símbolo.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Tipo",
      colPnlJoule: "PnL (JOULE)",
      tpSl: "Take profit / stop loss",
      takeProfitPhFull: "Pausar após lucro líquido semanal — opcional (JOULE)",
      stopLossPhFull: "Pausar após perda líquida semanal — opcional (JOULE)",
      confirmModify: "Confirmar",
      clearSearch: "Voltar ao ranking",
      searchResultHint: "Resultados da busca (toque para abrir o perfil do trader)",
      searchEmpty: "Trader não encontrado",
      noMoreSettlements: "Não há mais"
    },
    errors: {
      AUTH_REQUIRED: "Conecte sua carteira primeiro",
      AUTH_UNAVAILABLE: "O serviço de login está temporariamente indisponível. Tente novamente mais tarde.",
      POSTGRES_REQUIRED: "Serviço temporariamente indisponível. Tente novamente mais tarde.",
      USER_NOT_FOUND: "Usuário não encontrado. Faça login novamente e tente de novo.",
      INVALID_WALLET: "Informe um endereço completo da carteira",
      INVALID_QUERY: "Consulta inválida; digite pelo menos 2 caracteres",
      INVALID_AMOUNT: "Formato de valor inválido",
      INVALID_PARAM: "Parâmetros inválidos. Verifique e tente novamente.",
      INVALID_FOLLOW: "Você não pode copiar suas próprias operações",
      TRADER_EXISTS: "Esta carteira já é trader. Não é necessário registrar novamente.",
      TRADER_FULL: "Este trader atingiu o limite de seguidores",
      TRADER_CANCELLED: "Esta conta de trader foi cancelada",
      TRADER_REGISTER_FAILED: "Falha ao registrar como trader. Tente novamente mais tarde.",
      TRADER_SETTINGS_FAILED: "Falha ao salvar configurações do trader. Tente novamente mais tarde.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Saldo disponível insuficiente para congelar o depósito",
      BALANCE_TOO_LOW: "Saldo da conta copy abaixo do limite deste trader. Transfira da conta de trading primeiro",
      COPY_BALANCE_ZERO: "Saldo da conta copy é 0. Transfira da conta de trading primeiro",
      INSUFFICIENT_FUNDS: "Saldo da conta de trading insuficiente para transferir para a conta copy",
      COPY_TRADE_BALANCE_INSUFFICIENT: "Saldo disponível da conta copy insuficiente (stake/share congelados não podem sair)",
      ACCOUNT_NOT_FOUND: "Erro de conta. Tente novamente mais tarde.",
      ACCOUNT_CONFLICT: "Conta sendo atualizada. Tente novamente mais tarde.",
      FOLLOW_EXISTS: "Você já segue este trader",
      FOLLOW_LIMIT: "Você já tem uma relação de cópia ativa. Encerre antes de seguir outro trader.",
      FOLLOW_FAILED: "Falha ao iniciar a cópia. Tente novamente mais tarde.",
      FOLLOW_NOT_FOUND: "Relação de cópia não encontrada",
      PAUSE_FAILED: "Falha ao pausar a cópia. Tente novamente mais tarde.",
      RESUME_FAILED: "Falha ao retomar a cópia. Tente novamente mais tarde.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Falha ao encerrar a cópia. Tente novamente mais tarde.",
      APPLICATION_NOT_FOUND: "Solicitação pendente não encontrada",
      APPROVE_FAILED: "Falha ao aprovar a solicitação. Tente novamente mais tarde.",
      REJECT_FAILED: "Falha ao rejeitar a solicitação. Tente novamente mais tarde.",
      KICK_FAILED: "Falha ao remover o seguidor. Tente novamente mais tarde.",
      SETTLEMENT_WINDOW: "Configurações do trader não podem ser alteradas durante a janela de liquidação",
      CANCEL_FAILED: "Falha ao solicitar cancelamento. Tente novamente mais tarde.",
      CANCEL_NOT_PENDING: "Não há solicitação de cancelamento para retirar",
      CANCEL_WITHDRAW_FAILED: "Falha ao retirar cancelamento. Tente novamente mais tarde.",
      COPY_SETTINGS_MISSING: "Configurações de copy trading não estão prontas. Tente novamente mais tarde.",
      INVALID_SYMBOL: "Selecione pelo menos um símbolo compatível",
      SYMBOL_NOT_ALLOWED: "Inclui um símbolo que este trader não permite",
      TRADER_BALANCE_TOO_LOW: "Saldo disponível após congelar o depósito é baixo demais para registrar",
      TIMEOUT: "A operação falhou. Tente novamente mais tarde.",
      NETWORK: "A operação falhou. Tente novamente mais tarde."
    },
    status: {
      ACTIVE: "Ativo",
      PAUSED: "Pausado",
      ENDED: "Encerrado",
      PENDING_REVIEW: "Aguardando revisão do trader",
      CANCEL_PENDING: "Cancelamento pendente",
      CANCELLED: "Cancelado"
    },
    traderStatus: {
      ACTIVE: "Liderando",
      CANCEL_PENDING: "Saindo",
      CANCELLED: "Cancelado",
    },
    pauseReason: {
      USER: "Pausado pelo usuário",
      INSUFFICIENT_BALANCE: "Pausado: saldo da conta copy insuficiente",
      TAKE_PROFIT: "Take profit acionado",
      STOP_LOSS: "Stop loss acionado",
      TRADER_KICK: "Removido pelo trader",
      SWITCH: "Trader trocado",
      SETTLEMENT_CLEANUP: "Removido na liquidação semanal",
      TRADER_CANCEL: "Trader cancelado"
    },
    followMode: {
      EQUAL: "Valor igual",
      RATIO: "Proporção"
    },
    insuranceMode: {
      FOLLOW: "Seguir trader",
      ALWAYS_ON: "Sempre ativo",
      ALWAYS_OFF: "Sempre inativo"
    },
    reviewMode: {
      AUTO: "Follow automático",
      MANUAL: "Follow com revisão"
    },
    applicationStatus: {
      PENDING: "Pendente",
      APPROVED: "Aprovado",
      REJECTED: "Rejeitado",
      CANCELLED: "Cancelado",
      PENDING_REVIEW: "Pendente"
    }
  },}
